const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const token = () => localStorage.getItem('brolax_admin_token');

async function request(endpoint, options = {}) {
  const config = {
    headers: {
      'Content-Type': 'application/json',
      ...(token() && { Authorization: `Bearer ${token()}` }),
    },
    ...options,
  };
  
  const res = await fetch(`${API_BASE}${endpoint}`, config);
  
  // Check if response is JSON before parsing
  const contentType = res.headers.get('content-type');
  if (contentType && contentType.includes('application/json')) {
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'حدث خطأ');
    return data;
  } else {
    // Non-JSON response (likely HTML error page)
    if (!res.ok) throw new Error('خطأ في الخادم - الرجاء المحاولة مرة أخرى');
    return res;
  }
}

export const login = (username, password) =>
  request('/auth/login', { method: 'POST', body: JSON.stringify({ username, password }) });

export const getMe = () => request('/auth/me');

export const getProducts = (params = {}) => {
  const query = new URLSearchParams(params).toString();
  return request(`/products${query ? `?${query}` : ''}`);
};

export const getProduct = (slug) => request(`/products/${slug}`);

// These are for JSON requests (not used by the form, which uses fetch directly)
export const createProduct = (data) =>
  request('/products', { method: 'POST', body: JSON.stringify(data) });

export const updateProduct = (id, data) =>
  request(`/products/${id}`, { method: 'PUT', body: JSON.stringify(data) });

export const deleteProduct = (id) =>
  request(`/products/${id}`, { method: 'DELETE' });

export const getOrders = () => request('/orders');
export const getOrder = (id) => request(`/orders/${id}`);

export const updateOrderStatus = (id, status) =>
  request(`/orders/${id}/status`, { method: 'PUT', body: JSON.stringify({ status }) });